import Report from 'bugsnag-js/types/report'
import redactors from '../redactors';
import values from 'ramda/src/values';
import ReportRedactor from './ReportRedactor'
import { IValueRedactor } from '../redactors/IValueRedactor';

export default (report: Report): void => {
    values(redactors).forEach((redactor: IValueRedactor) => {
        ReportRedactor(report, redactor);
    });
}


// WEBPACK FOOTER //
// ./packages/platform-utils/logging/bugsnag/SensitiveDataRedactor.ts